import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAMPStore } from "@/store/asset-management-plan";
import LinkTable from "./LinkTable.vue";
import { ReliabilityMetricsLink } from "@/classes";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReliabilityMetricsLinkTable',
  props: {
    readonly: { type: Boolean }
  },
  emits: ["delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useAMPStore();

const addLink = (link: string) => {
  const newLink = new ReliabilityMetricsLink();
  newLink.asset_management_plan_id = store.plan.id;
  newLink.link = link;
  store.plan.reliability_metrics_links.push(newLink);
};

const updateLink = (id: string, value: string) => {
  const link = store.plan.reliability_metrics_links.find((l) => l.id === id);
  if (link) {
    link.link = value;
  }
};

const deleteLink = (id: string) => {
  const index = store.plan.reliability_metrics_links.findIndex(
    (l) => l.id === id,
  );
  if (index !== -1) {
    const link = store.plan.reliability_metrics_links[index];
    store.plan.reliability_metrics_links.splice(index, 1);
    emit("delete", link);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LinkTable, {
    label: "6.2.1 Reliability Metrics Links",
    links: _unref(store).plan.reliability_metrics_links,
    readonly: _ctx.readonly,
    onAdd: _cache[0] || (_cache[0] = ($event: any) => (addLink($event))),
    onUpdate: _cache[1] || (_cache[1] = ($event: any) => (updateLink($event.id, $event.link))),
    onDelete: _cache[2] || (_cache[2] = ($event: any) => (deleteLink($event)))
  }, null, 8, ["links", "readonly"]))
}
}

})